import { ArsTableState, ArstActionUpdateScaffold } from "../interface";
import { buildArsTableScaffoldModel } from "./buildArsTableScaffoldModel";

/**
 * Rebuilds scaffold state from recalculated table rows.
 *
 * @param state - Current ARS table state
 * @param action - Scaffold update action containing recalculated rows
 * @returns Updated ARS table state
 */
export const arst_updateScaffold = <T>(
  state: ArsTableState<T>,
  action: ArstActionUpdateScaffold<T>,
): ArsTableState<T> => ({
  ...state,
  calculatedTableRows: action.calculatedTableRows,
  scaffoldModel: buildArsTableScaffoldModel(action.calculatedTableRows, state.settings.editorProps),
});
